import React from "react";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { HiInformationCircle } from "react-icons/hi2";
import IconButton from "@mui/material/IconButton";
interface StatisticData {
    name: string;
    value_current_year: string | number; // Allow both string (for parseFloat) and number (for 0 comparison)
    change: number;
}

interface Statistic {
    display_main: boolean;
    statistic_type: string; // Can be more specific if needed, e.g., "comparison"
    data: StatisticData;
}

interface ClientStatisticsProps {
    statistics: Statistic[];
    onNavigateToTab?: () => void;
}

const ClientStatistics: React.FC<ClientStatisticsProps> = ({
    statistics,
    onNavigateToTab,
}) => {
    return (
        <div className="w-full pl-2 pr-2 mt-4">
            <div className="flex flex-col border border-gray-200 rounded-md justify-center w-full p-2">
                <div className="flex items-center text-left text-base md:text-base xl:text-base font-bold text-black mb-2">
                    Statistiques clés
                    <Tooltip title="Depuis le 1er janvier vs l'année dernière">
                        <IconButton
                            size="small"
                            sx={{
                                padding: 0,
                                marginLeft: "4px",
                                verticalAlign: "middle",
                            }}
                        >
                            <HiInformationCircle />
                        </IconButton>
                    </Tooltip>
                    {onNavigateToTab && (
                        <button
                            onClick={onNavigateToTab}
                            className="ml-auto px-2 py-1 text-sm font-semibold underline rounded"
                            style={{ color: "#084347" }}
                        >
                            Voir tout
                        </button>
                    )}
                </div>

                <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {statistics.length > 0 &&
                    statistics.some(
                        (stat) =>
                            stat.display_main &&
                            stat.statistic_type === "comparison"
                    ) ? (
                        statistics
                            .filter(
                                (stat) =>
                                    stat.display_main &&
                                    stat.statistic_type === "comparison"
                            )
                            .sort((a, b) =>
                                a.data.name.localeCompare(b.data.name)
                            )
                            .map((stat, index) => (
                                <Grid
                                    key={index}
                                    size={{ xs: 2, sm: 3, md: 3 }}
                                    sx={{
                                        backgroundColor: "#F3F4F6",
                                        borderRadius: "8px",
                                        padding: "8px",
                                    }}
                                >
                                    <div className="w-full flex flex-row justify-between items-center">
                                        <div className="text-left w-2/3 text-sm">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: stat.data.name,
                                                }}
                                            />
                                        </div>
                                        <div
                                            className={`rounded-full text-black text-sm w-12 h-5 py-1 flex items-center justify-center`}
                                        >
                                            {isNaN(
                                                parseFloat(
                                                    stat.data
                                                        .value_current_year as string
                                                )
                                            )
                                                ? "0"
                                                : parseFloat(
                                                      stat.data
                                                          .value_current_year as string
                                                  ).toFixed(0)}
                                        </div>

                                        <div
                                            style={{
                                                backgroundColor:
                                                    stat.data.change < 0
                                                        ? "#FF3838"
                                                        : "#C3FF36",
                                            }}
                                            className={`flex text-xs px-1 md:text-sm items-center justify-center rounded-md ${
                                                stat.data.change > 0
                                                    ? "bg-gold text-black"
                                                    : "text-white"
                                            } w-1/6`}
                                        >
                                            {isNaN(
                                                parseFloat(
                                                    stat.data
                                                        .value_current_year as string
                                                )
                                            ) ||
                                            stat.data.value_current_year ===
                                                0 ? (
                                                <>
                                                    <span className="ml">
                                                        100%
                                                    </span>
                                                </>
                                            ) : stat.data.change > 0 ? (
                                                <>
                                                    <span className="ml">
                                                        {Number(
                                                            stat.data.change
                                                        ).toFixed(0)}
                                                        %
                                                    </span>
                                                </>
                                            ) : stat.data.change < 0 ? (
                                                <>
                                                    <span className="ml">
                                                        {Number(
                                                            stat.data.change
                                                        ).toFixed(0)}
                                                        %
                                                    </span>
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                </Grid>
                            ))
                    ) : (
                        <div className="text-gray-500 text-center mt-4">
                            Pas de vente depuis le 1er janvier.
                        </div>
                    )}
                </Grid>
            </div>
        </div>
    );
};

export default ClientStatistics;
